import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
	useTheme
} from '@mui/joy';
import ControlPanelLayout, {
	IControlPanelLayoutProps
} from '../Controls/ControlPanelLayout';
//import { DataKey } from '../../lib/model';
//import { useControls } from '../../providers/ControlProvider';
import DisaggChart from './DisaggChart';
import { useEdgeCases } from '../../providers/EdgeCaseProvider';
import { STATES_WITH_EDGE_CASES } from '../../lib/const';
import { useRoute } from '../../providers/RouteProvider';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useChartSectionData } from '../../providers/ChartSectionProvider';
import RadialChart from './RadialChart';
import { DataKey } from '../../lib/model';
import { Fragment } from 'react';

interface IProps extends IControlPanelLayoutProps {
	topic: string;
	accordionIndex: number | null;
	setAccordionIndex: (arg0: number | null) => void;
	print?: boolean;
}
const ProportionLayout = ({
	topic,
	page,
	title,
	text,
	accordionIndex,
	setAccordionIndex,
	print = false
}: IProps) => {
	const theme = useTheme();
	const { chartData } = useChartSectionData();
	const { listOfOffices } = useEdgeCases();

	const { selectedState, election, raceFilter } = useRoute(); //useControls();

	const isFilteredByRace: boolean = raceFilter[0] === 'true';

	const hasEdgeCases =
		STATES_WITH_EDGE_CASES.includes(selectedState as string) &&
		page === 'state';
	const matchesLG = useMediaQuery(theme.breakpoints.up(1140));
	const matchesMD = useMediaQuery(theme.breakpoints.up(850));

	const hasGroupsThatNeedLegend = () => {
		const groups = chartData
			?.map((array) => {
				return array.map((item) => item.group);
			})
			.flat();
		const xx = groups
			.map((grp) => {
				if (grp.length) {
					if (
						grp.includes('MENA') ||
						grp.includes('NatAm') ||
						grp.includes('AAPI')
					)
						return true;
				} else return null;
			})
			.filter((item) => item);
		return xx.length ? true : false;
	};
	const showLegend = hasGroupsThatNeedLegend();

	const gridLayout = () => {
		if (hasEdgeCases && election === 'state') {
			if (matchesLG) return '1fr 1fr 1fr';
			else if (matchesMD) return '1fr 1fr';
			else return '1fr';
		} else if (matchesMD) return '1fr 1fr';
		else return '1fr';
	};

	const getFirstRowCount = () => {
		if (hasEdgeCases && election === 'state') {
			if (matchesLG) return 3;
			else if (matchesMD) return 2;
			else return 1;
		} else if (matchesMD) return 2;
		else return 1;
	};

	const extendedList = listOfOffices?.concat(['State Senate', 'State House']);
	return (
		<>
			<ControlPanelLayout page={page} title={title} text={text} print={print} />
			<Box
				sx={{
					backgroundColor: theme.palette.chartElementsBackground.bg,
					height: '100%',
					padding: { xs: '1rem .5rem', sm: '1rem 3rem' }
					//mx: '-3rem'
				}}
			>
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: gridLayout(),
						flexGrow: 1
					}}
				>
					{/* edgecases */}
					{page === 'state' && election === 'state' && hasEdgeCases ? (
						<>
							{extendedList?.map((office, index) => {
								return index < getFirstRowCount() ? (
									<Fragment key={office}>
										{isFilteredByRace && election === 'state' ? (
											<DisaggChart
												type={'pct'}
												reorder={true}
												topic={topic}
												office={office}
												chartData={chartData[index]}
												page={page}
												print={print}
											/>
										) : (
											<RadialChart
												office={office}
												topic={topic}
												small={true}
												index={index}
												chartData={chartData[index]}
												count={getFirstRowCount()}
												print={print}
											/>
										)}
									</Fragment>
								) : null;
							})}
						</>
					) : (
						// when no edgecases
						<>
							{isFilteredByRace && election === 'state' ? (
								<DisaggChart
									type={'pct'}
									reorder={true}
									topic={topic}
									office={'State Senate'}
									chartData={chartData[0]}
									page={page}
									print={print}
								/>
							) : (
								<RadialChart
									office={'State Senate'}
									topic={topic}
									small={
										(hasEdgeCases &&
											election === 'state' &&
											page === 'state') ||
										!matchesLG
									}
									page={page}
									chartData={chartData[0]}
									count={getFirstRowCount()}
									print={print}
								/>
							)}

							{(isFilteredByRace && election === 'state') ||
							election === 'congress' ||
							page === 'national' ? (
								<DisaggChart
									type={'pct'}
									reorder={true}
									topic={topic}
									office={'State House'}
									page={page}
									chartData={chartData[1]}
									print={print}
								/>
							) : (
								<RadialChart
									office={'State House'}
									topic={topic}
									small={hasEdgeCases || !matchesLG}
									chartData={chartData[1]}
									count={getFirstRowCount()}
									print={print}
								/>
							)}
						</>
					)}
				</Box>

				{election === 'state' &&
				hasEdgeCases &&
				(extendedList as string[]).length > getFirstRowCount() ? (
					<Accordion
						expanded={accordionIndex === 0}
						onChange={(_event, expanded) => {
							if (topic === DataKey.PropSelf)
								setAccordionIndex(expanded ? 0 : null);
							else if (topic === DataKey.PropSmall)
								setAccordionIndex(expanded ? 0 : null);
						}}
						sx={{
							boxShadow: 'none',
							position: 'unset',
							marginTop: '1rem'
						}}
					>
						<AccordionSummary
							sx={{
								padding: 0,
								justifyContent: 'flex-start',
								'> button': { justifyContent: 'unset' }
							}}
						>
							{accordionIndex === 0 ? 'See Less' : 'See More'}
						</AccordionSummary>
						<AccordionDetails
							sx={{
								//padding: '2rem 0',
								flexGrow: 1
							}}
						>
							<Box
								sx={{
									display: 'grid',
									gridTemplateColumns: gridLayout,
									flexGrow: 1
								}}
							>
								{/* //rest of edgecases */}
								{election === 'state' && hasEdgeCases ? (
									<>
										{extendedList?.map((office, index) => {
											return index >= getFirstRowCount() ? (
												<>
													{isFilteredByRace && election === 'state' ? (
														<DisaggChart
															type={'pct'}
															reorder={true}
															topic={topic}
															office={office}
															chartData={chartData[index]}
															page={page}
															print={print}
														/>
													) : (
														<RadialChart
															office={office}
															topic={topic}
															small={true}
															index={index}
															chartData={chartData[index]}
															count={getFirstRowCount()}
															print={print}
														/>
													)}
												</>
											) : null;
										})}
									</>
								) : null}
							</Box>
						</AccordionDetails>
					</Accordion>
				) : null}
			</Box>
			{showLegend ? (
				<Typography
					sx={{
						padding: '0 2rem 1rem 3rem',
						backgroundColor: theme.palette.chartElementsBackground.bg
					}}
				>
					MENA - Middle Eastern/North African &nbsp; NatAm - Native
					American/Alaska Native/Native Hawaiian &nbsp; AAPI - Asian
					American/Pacific Islander
				</Typography>
			) : null}
		</>
	);
};

export default ProportionLayout;
